import React from 'react';
import { Drawer, Box, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NavigationItems } from './NavigationItems';
import logo from '../../../assets/logo.png';

interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const MobileDrawer: React.FC<MobileDrawerProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/app/dashboard');
    onClose(); // Close the drawer after navigation
  };

  // Only render on mobile
  if (!isMobile) {
    return null;
  }

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      variant="temporary"
      ModalProps={{
        keepMounted: true, // Better open performance on mobile
      }}
      sx={{
        zIndex: theme.zIndex.drawer + 2, // Higher than AppBar
        '& .MuiDrawer-paper': {
          width: 280,
          boxSizing: 'border-box',
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header with Logo */}
        <Box
          onClick={handleLogoClick}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mt: 3,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
            },
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Lecturo Logo"
            sx={{
              maxWidth: 40,
              maxHeight: 40,
              mb: 1.5,
            }}
          />
        </Box>

        {/* Navigation Items - using shared component */}
        <Box
          sx={{
            flexGrow: 1,
            px: 1,
            py: 1,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            minHeight: 0,
          }}
        >
          <NavigationItems onItemClick={onClose} variant="mobile" />
        </Box>
      </Box>
    </Drawer>
  );
};
